import { useCart } from "../../context/CartContext";
import { Button } from "../Button";
import { useTranslation } from "react-i18next";
import { useLocalizedNavigation } from "../../hooks/useLocalizedNavigation";

export const HeaderMobileCartPanel = ({ isOpen, close }) => {
  const { t } = useTranslation("common");
  const { cartItems, clearCart, removeFromCart } = useCart();
  const { navigateLocalized } = useLocalizedNavigation();

  if (!isOpen) return null;

  return (
    <div className={`mobile__cart ${isOpen ? "mobile__cart--open" : ""}`}>
      <h3>{t("cart.title")}</h3>

      <ul className="cart-modal__container__list">
        {cartItems.map((item) => (
          <li
            key={item.id}
            className="cart-modal__item"
            onClick={() => navigateLocalized(item.url)}
            style={{ cursor: "pointer" }}
          >
            <span>{item.name}</span>

            <input
              type="checkbox"
              checked
              onClick={(e) => e.stopPropagation()} // evita que clique no checkbox dispare o navigate
              onChange={() => removeFromCart(item.id)}
              className="card__checkbox"
            />
          </li>
        ))}
      </ul>

      <Button
        text={t("cart.requestConsultation")}
        classe={"button--white-variant"}
        style={{ width: "100%" }}
        evento={() => navigateLocalized("/contacts")}
      />
      <Button
        text={t("cart.clearCart")}
        classe="button--red"
        style={{ width: "100%" }}
        evento={clearCart}
      />
    </div>
  );
};
